export default {
  sales: {
    EventName: '活动名称',
    PromotionTime: '促销日期',
    ProductName: '商品名称',
    Type: '类型',
    StartTime: '开始日期',
    PromotionType: '促销类型',
    EndTime: '结束日期',
    PromotionArea: '促销区域',
    Status: '状态',
    PromotionObject: '促销对象',
    CreateTime: '创建日期',
    ModifyTime: '最近修改日期',

    NewGift: '新增满赠',
    NewDecline: '新增直降',
    NewDiscount: '新增打折',

    ProductGift: '商品满赠',
    ProductDecline: '商品直降',
    ProductDiscount: '商品打折',
    QuantityGift: '数量满赠',
    QuantityDecline: '数量直降',
    QuantityDiscount: '数量打折',
    OrderGift: '订单满赠',
    OrderDecline: '订单直降',
    OrderDiscount: '订单打折',

    ProductCode: '商品编号',
    PromotionRules: '促销规则',
    PromotionalGoods: '促销商品',
    ActivityTime: '活动时间',
    Quantity: '数量',
    Gift: '赠品',
    NoData: '暂无数据',
    OrderPrice: '订单满(元)',
    OrderPriceDecline: '订货价降至(元)',
    CustomerType: '客户类型',
    Dealer: '客户',
    Area: '区域',
    SelectAll: '全选',
    DiscountOnTheOriginalOrderPrice: '在原订货价基础上再打折',
    ProductSelect: '商品选择',
    AreaSelect: '区域选择',
    DealerSelect: '客户选择',
    CustomerTypeSelect: '请至少选择一个客户类型',
    DealerCode: '客户编号',
    DealerName: '客户名称',
    PleaseChooseDate: '请选择日期',
    CanNotBeEmpty: '活动名称不能为空',
    NoSpaces: '不能有空格'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mcc/sales/sales.js